import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { URL} from 'src/app/tools/URL';

@Component({
  selector: 'denuncia-anonima-aviso',
  templateUrl: './denuncia-anonima-aviso.component.html',
  styleUrls: ['./denuncia-anonima-aviso.component.css']
})
export class DenunciaAnonimaAvisoComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  denunciaAnonimaRecomendacoes() {
    this.router.navigate([URL.DENUNCIA_ANONIMA_RECOMENDACOES]);
  }

}
